import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import React from "react";

import { language } from "../../../language";
import { getPropertie } from "../../smart/camunda/forms/functions";

export default function ExtraFieldsComponent(props) {
  const {
    handleDefaultValueChangeOnBlurApi,
    addRowDefaultValueOnExtraFieldsApi,
    deleteDefaultValueRowExtraFieldsApi,
    state,
  } = props;

  const onBlurapiProp = getPropertie(state?.properties, "extraFields_api");

  return (
    <React.Fragment>
      <React.Fragment>
        <Button
          variant="contained"
          color="primary"
          id="extraFields_api"
          onClick={(event) => {
            addRowDefaultValueOnExtraFieldsApi(event, "extraFields_api");
          }}
          startIcon={<AddIcon />}
        >
          {language.addNewOnblur}
        </Button>
        <table id="table" className="table table-hover">
          <thead>
            <tr>
              <th>{language.apifield}</th>
              <th>{language.smartField}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {onBlurapiProp &&
              onBlurapiProp.mapFields &&
              onBlurapiProp.mapFields.map((item, index) => {
                return (
                  <tr key={`tr_${index}`}>
                    <td>
                      <input
                        name="api"
                        value={onBlurapiProp.mapFields[index].api}
                        onChange={(event) =>
                          handleDefaultValueChangeOnBlurApi(
                            event,
                            index,
                            "extraFields_api",
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        name="smart"
                        value={onBlurapiProp.mapFields[index].smart}
                        onChange={(event) =>
                          handleDefaultValueChangeOnBlurApi(
                            event,
                            index,
                            "extraFields_api",
                          )
                        }
                      />
                    </td>
                    <td>
                      <DeleteIcon
                        onClick={() =>
                          deleteDefaultValueRowExtraFieldsApi(
                            index,
                            "extraFields_api",
                          )
                        }
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </React.Fragment>
    </React.Fragment>
  );
}
